import React from 'react';
import { Select } from 'mui-rff';

export default function SelectAdapter({content, idKey='id', nameKey = 'name', variant, ...rest}) {

  return (<Select
    variant={variant || 'outlined'}
    {...rest}
    data={content && content.map(item => ({value: item[idKey], label: item[nameKey]}))}
  />)

}